module.exports = __webpack_public_path__ + "static/media/american_express.3b680b84.svg";